module.exports = __webpack_public_path__ + "img/jd.4022d4d7.jpg";